<template>
    <div class="conetent" style="background-color: #fff;">
        <div class="nTop" >
            <div class="wrapper clearfix">
                <a  class="logo"><img src="../../assets/images/logo.jpg" alt="佰吉宏安国际能源有限公司"><h1>佰吉宏安国际能源有限公司</h1></a>
                <a class="nt-link1"><router-link  to="/home">返回首页</router-link></a>
            </div>
        </div>
        <img src="../../assets/images/register-img_01.png" alt="">
        <div class="title">交易商信息</div>

        <div class="tab">
            <div class="tab__item" :class="{active: type == 2}" @click="type = 2">企业</div>
            <div class="tab__item" :class="{active: type == 1}" @click="type = 1">个人</div>
        </div>

        <div class="main" v-if="type == 2">
            <div class="main__item">
                <div class="input-box">
                    <span>企业名称</span>
                    <div class="">
                        <div class="input"><input type="text" v-model="business.business" placeholder="请输入企业名称"></div>
                        <div v-show="business.isBusiness" class="tip">请输入企业名称</div>
                    </div>
                </div>
                <div class="input-box">
                    <span>用户名</span>
                    <div class="">
                        <div class="input"><input type="text" v-model="business.name" maxlength="16"  placeholder="请输入用户名"></div>
                        <div class="tip"></div>
						<!-- 用户名限制在4-16位 -->
                    </div>
                </div>
                <div class="input-box">
                    <span>登录密码</span>
                    <div class="">
                        <div class="input"><input type="password" v-model="business.psd" maxlength="20"  placeholder="请输入登录密码"></div>
                        <div class="tip">登录密码限制在6-20位</div>
                    </div>
                </div>
                <div class="input-box">
                    <span>确认密码</span>
                    <div class="">
                        <div class="input"><input type="password" v-model="business.psds" placeholder="请确认密码"></div>
                        <div v-show="business.isPsds" class="tip">请确认密码</div>
                    </div>
                </div>
                <div class="input-box">
                    <span>企业地址</span>
                    <div class="">
                        <div class="input"><input type="text" v-model="business.adds" placeholder="请输入企业地址"></div>
                        <div v-show="business.isAdds" class="tip">请输入企业地址</div>
                    </div>
                </div>
                <div class="input-box">
                    <span>企业邮箱</span>
                    <div class="">
                        <div class="input"><input type="text" v-model="business.email" placeholder="请输入邮箱"></div>
                        <div v-show="business.isEmail" class="tip">请输入邮箱</div>
                    </div>
                </div>
            </div>

            <div>
                <div class="input-box">
                    <span>法人代表</span>
                    <div class="">
                        <div class="input"><input type="text" v-model="business.legal" placeholder="请输入法人代表"></div>
                        <div v-show="business.isLegal" class="tip">请输入法人代表</div>
                    </div>
                </div>
                <div class="upload-box">
                    <span>资质上传</span>
                    <div class="">
						<!-- <div>
							qualifications
						</div> -->
						<el-upload
						  class="upload-demo"
						  action="https://baijihongan.com/api/v1/filemanager"
						  name="imgFile"
						  accept=".pdf"
						  :limit="limit"
						  :data="fileData"
						  :on-preview="handlePreview"
						  :on-remove="handleRemove"
						  :before-remove="beforeRemove"
						  :on-exceed="handleExceed"
						  :on-success="beforSuccess"
						  :file-list="fileList">
							<div>
								 <el-button type="primary">&emsp;&emsp;上传&emsp;&emsp;</el-button>
							</div>
						  <div class="tip">营业执照副本、开户许可、开票信息的扫描件并加盖<br>公章，PDF格式上传</div>
						</el-upload>
                    </div>
                </div>
                <div class="input-box" style="margin-top: 10px;">
                    <span>联系人</span>
                    <div class="">
                        <div class="input"><input type="text" v-model="business.contactName" placeholder="请输入联系人"></div>
                        <div v-show="business.isContactName" class="tip">请输入联系人</div>
                    </div>
                </div>
                <div class="input-box">
                    <span>联系电话</span>
                    <div class="">
                        <div class="tel">
                            <div class="input"><input type="text" v-model="mobile" placeholder="请输入联系电话"></div>
                            <el-button @click="sendYanzheng" type="primary">{{send}}</el-button>
                        </div>
                        <div class="tip" v-show="isMobile" >请输入联系电话</div>
                    </div>
                </div>
                <div class="input-box">
                    <span>验证码</span>
                    <div class="">
                        <div class="input"><input type="text" v-model="yzm" placeholder="请输入验证码"></div>
                        <div v-show="isYzm" class="tip">请输入验证码</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main" v-else-if="type == 1">
            <div class="main__item">
                <div class="input-box">
                    <span>用户名</span>
                    <div class="">
                        <div class="input"><input type="text" v-model="user.name" maxlength="16"  placeholder="请输入用户名"></div>
						 <div class="tip"></div>
						 <!-- 用户名限制在4-16位 -->
                    </div>
                </div>
                <div class="input-box">
                    <span>登录密码</span>
                    <div class="">
                        <div class="input"><input type="password" v-model="user.psd" maxlength="20"  placeholder="请输入登录密码"></div>
                        <div class="tip">登录密码限制在6-20位</div>
                    </div>
                </div>
                <div class="input-box">
                    <span>确认密码</span>
                    <div class="">
                        <div class="input"><input type="password" v-model="user.psds" placeholder="请确认密码"></div>
                        <div v-show="user.isPsds" class="tip">请确认密码</div>
                    </div>
                </div>
                <div class="input-box">
                    <span>电子邮箱</span>
                    <div class="">
                        <div class="input"><input type="text" v-model="user.email" placeholder="请输入电子邮箱"></div>
                        <div v-if="user.isEmail" class="tip">请输入电子邮箱</div>
                    </div>
                </div>
            </div>

            <div>
                <div class="input-box">
                    <span>联系人</span>
                    <div class="">
                        <div class="input"><input v-model="user.contactName" type="text" placeholder="请输入联系人"></div>
                        <div v-if="user.isContactName" class="tip">请输入联系人</div>
                    </div>
                </div>
                <div class="input-box">
                    <span>联系电话</span>
                    <div class="">
                        <div class="tel">
                            <div class="input"><input v-model="mobile" type="text" placeholder="请输入联系电话"></div>
                            <el-button @click="sendYanzheng" type="primary">{{send}}</el-button>
                        </div>
                        <div v-show="isMobile" class="tip">请输入联系电话</div>
                    </div>
                </div>
                <div class="input-box">
                    <span>验证码</span>
                    <div class="">
                        <div class="input"><input  v-model="yzm" type="text" placeholder="请输入验证码"></div>
                        <div v-show="isYzm" class="tip">请输入验证码</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="agreement">
            <el-checkbox v-model="checked">
                同意<router-link to="/clause"><span>《用户协议》</span></router-link>和<router-link to="/clause"><span>《隐私政策》</span></router-link>
            </el-checkbox>
        </div>
        <button class="submit_btn" @click="register">注册并登录</button>

		<el-dialog
			custom-class="dialog"
		  :visible.sync="show"
		  :show-close="false"
		  :close-on-click-modal="false"
		  width="25%">
			<div class="pop_box">
				<div class="pop_image_box" style="margin-bottom: 10px;">
					<img src="../../assets/images/ico17.png"></img>
					注册成功
				</div>
				<div class="pop_tip" style="width: 100%;">
					<span style="font-size: 16px;">请注意！</span></br>注册个人用户将不能使用竞拍功能！如需修改请前往个人中心
				</div>
				<div class="pop_btn" @click="goBack()">
					我知道了
				</div>
				
			</div>
		</el-dialog>

       <div class="footer">
       	<div class="wrapper">
       		<div class="f-nav">
       			<a href=""><router-link  to="/home">首页</router-link></a>
       			<a href=""><router-link  to="/about">关于我们</router-link></a>
       			<a href=""><router-link  to="/honor">资质荣誉</router-link></a>
       			<a href=""><router-link  to="/product">主营产品</router-link></a> 
       			<a href=""><router-link  to="/bidding">招标信息</router-link></a>
       			<a href=""><router-link  to="/partner">合作伙伴</router-link></a>
       			<a href=""><router-link  to="/news">新闻资讯</router-link></a>
       			<a href=""><router-link  to="/contact">联系我们</router-link></a>
       		</div>
       		<div class="f-box flexbox">
       			<img src="../../assets/images/logo_foot.png" alt="佰吉宏安国际能源有限公司" class="logo_foot">
       			<div class="f-center flexbox33 flexwarp" style="text-align: left;">
       				<div class="f-item clearfix"><img src="../../assets/images/ico05.png"><p>联系电话：{{footerMassage.mobile}}</p></div>
       				<div class="f-item clearfix"><img src="../../assets/images/ico06.png"><p>邮政编码：{{footerMassage.postal}}</p></div>
       				<div class="f-item clearfix"><img src="../../assets/images/ico07.png"><p>访问量：{{footerMassage.pageviews}}</p></div>
       				<div class="f-item clearfix"><img src="../../assets/images/ico08.png"><p>电子邮箱：{{footerMassage.email}}</p></div>
       				<div class="f-item clearfix"><img src="../../assets/images/ico09.png"><p>公司地址：{{footerMassage.address}}</p></div>
       				<div class="f-item clearfix"><img src="../../assets/images/ico10.png"><p>交易量：{{footerMassage.trading_volume}}</p></div>
       			</div>
       			<div class="qrcode">
       				<img :src="footerMassage.image_id5_url" alt="">
       				<p>扫一扫了解更多</p>
       			</div>
       		</div>
       		<div class="copyright">
       			Copyright  2021 ·版权所有 佰吉宏安国际能源有限公司　　<a  href="https://beian.miit.gov.cn" target="_blank">{{footerMassage.site_icp}}&nbsp;{{footerMassage.site_wabah}}</a><br>
       			建议使用1920*1080以上的屏幕分辨率和8.0以上版本的浏览器来访问本站，本站不支持IE浏览器
       		</div>
       	</div>
       </div>
    </div>
</template>

<script>
    export default {
        name: 'register',
        data() {
            return {
                type: 2, // 2企业 1个人
                checked: false,
				fileList:[],
				limit:1,
				business:{
					business:'',//企业名
					isBusiness:false,//企业名称tip
					name:'',//企业用户名
					psd:'',//企业密码
					psds:'',//确认密码,
					isPsds:false,//确认密码tip
					adds:'',//企业地址
					isAdds:false,//企业地址tip
					email:'',//企业邮箱
					isEmail:false,//邮箱tip
					legal:'',//法人
					isLegal:false,//法人tip
					qualifications:'',//资质
					contactName:'',//联系人
					isContactName:false//联系人tip
				},
				user:{
					name:'',//用户名
					isName:false,
					psd:'',//密码
					psds:'',//确认密码,
					isPsds:false,//确认密码tip
					email:'',//邮箱
					isEmail:false,//邮箱tip
					contactName:'',//联系人
					isContactName:false//联系人tip
				},
				mobile:'',
				isMobile:false,
				send:'发送验证码',
				time: 60,
				yzm:'',
				isYzm:false,
				fileData:{
					type:'file',
					path:1,
					module:1
				},
				show:false,
				footerMassage:''
            }
        },
		mounted() {
			this.site_info()
		},
        methods: {
			//底部导航信息
			async site_info(idnex) {
			    let { status, message, data } = await this.$ajax('site_info', {
			    });
			    if (status == this.SUCCESS_CODE) {
			        
			      this.footerMassage = data
			    } else {
			        this.$message.error(message);
			    }
			},
			goBack(){
				 this.$router.go(-1);
			},
			register(){
				var _this = this
				
				if(_this.type == 2){
					if(_this.business.business == ''){
						_this.business.isBusiness = true
						_this.$message({
						  message: '请输入企业名称',
						  type: 'warning'
						});
						return false
					}else{
						_this.business.isBusiness = false
					}
					if(_this.business.name == ''){
						_this.$message({
						  message: '请输入用户名',
						  type: 'warning'
						});
						return false
					}
					if(_this.business.name.length < 2){
						_this.$message({
						  message: '用户名最小2位',
						  type: 'warning'
						});
						return false
					}
					if(_this.business.psd == ''){
						_this.$message({
						  message: '请输入密码',
						  type: 'warning'
						});
						return false
					}
					if(_this.business.psd.length < 6){
						_this.$message({
						  message: '登录密码最小6位',
						  type: 'warning'
						});
						return false
					}
					if(_this.business.psds == ''){
						_this.$message({
						  message: '请再次输入密码',
						  type: 'warning'
						});
						_this.business.isPsds = true
						return false
					}else{
						_this.business.isPsds = false
					}
					if(_this.business.psds != _this.business.psd){
						_this.$message({
						  message: '您两次输入的密码不同',
						  type: 'warning'
						});
						return false
					}
					if(_this.business.adds == ''){
						_this.business.isAdds = true
						_this.$message({
						  message: '请输入企业地址',
						  type: 'warning'
						});
						return false
					}else{
						_this.business.isAdds = false
					}
					if(_this.business.email == ''){
						_this.business.isEmail = true
						_this.$message({
						  message: '请输入企业邮箱',
						  type: 'warning'
						});
						return false
					}else{
						_this.business.isEmail = false
					}
					var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
					if(!reg.test(_this.business.email)){
						_this.$message({
						  message: '您的邮箱格式不正确',
						  type: 'warning'
						});
						return false
					}
					if(_this.business.legal == ''){
						_this.business.isLegal = true
						_this.$message({
						  message: '请输入法人姓名',
						  type: 'warning'
						});
						return false
					}else{
						_this.business.isLegal = false
					}
					
					if(_this.business.qualifications == ''){
						_this.$message({
						  message: '请上传资质',
						  type: 'warning'
						});
						return false
					}
					if(_this.business.contactName == ''){
						_this.business.isContactName = true
						_this.$message({
						  message: '请输入联系人姓名',
						  type: 'warning'
						});
						return false
					}else{
						_this.business.isContactName = false
					}
				}
				if(_this.type == 1){
					if(_this.user.name == ''){
						_this.$message({
						  message: '请输入用户名',
						  type: 'warning'
						});
						return false
					}
					if(_this.user.name.length < 2){
						_this.$message({
						  message: '用户名最小2位',
						  type: 'warning'
						});
						return false
					}
					if(_this.user.psd == ''){
						_this.$message({
						  message: '请输入密码',
						  type: 'warning'
						});
						return false
					}
					if(_this.user.psd.length < 6){
						_this.$message({
						  message: '登录密码最小6位',
						  type: 'warning'
						});
						return false
					}
					if(_this.user.psds == ''){
						_this.$message({
						  message: '请再次输入密码',
						  type: 'warning'
						});
						_this.user.isPsds = true
						return false
					}else{
						_this.user.isPsds = false
					}
					if(_this.user.psds != _this.user.psd){
						_this.$message({
						  message: '您两次输入的密码不同',
						  type: 'warning'
						});
						return false
					}
					if(_this.user.email == ''){
						_this.user.isEmail = true
						_this.$message({
						  message: '请输入企业邮箱',
						  type: 'warning'
						});
						return false
					}else{
						_this.user.isEmail = false
					}
					var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
					if(!reg.test(_this.user.email)){
						_this.$message({
						  message: '您的邮箱格式不正确',
						  type: 'warning'
						});
						return false
					}
					if(_this.user.contactName == ''){
						_this.user.isContactName = true
						_this.$message({
						  message: '请输入联系人姓名',
						  type: 'warning'
						});
						return false
					}else{
						_this.user.isContactName = false
					}
				}
				if (!/^1[2-9]\d{9}$/.test(_this.mobile)) {
					_this.$message({
					  message: '请输入有效的手机号',
					  type: 'warning'
					});
					_this.isMobile = true
				    return false;
				}else{
					_this.isMobile = false
				}
				if (_this.ysm == '') {
					_this.$message({
					  message: '请输入验证码',
					  type: 'warning'
					});
					_this.isYzm = true
					return false;
				}else{
					_this.isYzm = false
				}
				if(!_this.checked){
					_this.$message({
					  message: '请勾选同意《隐私政策》和《用户协议》',
					  type: 'warning'
					});
					return
				}
				this.submit()
			},
			async submit() {
				var _this = this;
				if(_this.type == 2){
					let { status, message, data } = await _this.$ajax('register', {
						business:_this.business.business,
						username:_this.business.name,	
						password:_this.business.psd,	
						address:_this.business.adds,		
						email:'',			
						legal:_this.business.legal,	
						qualifications:_this.business.qualifications,	
						contact_name:_this.business.contactName,	
						mobile:_this.mobile,	
						verify:_this.yzm,	
						type:_this.type,	
						business_email:	_this.business.email
					});
					if (status == _this.SUCCESS_CODE) {
						  _this.$message({
							message: '注册成功！审核状态可在个人中心查看',
							type: 'success'
						  });
						  _this.$setStorage('userToken',data.userToken)
						  _this.$router.go(-1);
					} else {
						 _this.$message.error(message);
					}
				}
				if(_this.type == 1){
					let { status, message, data } = await _this.$ajax('register', {
						business:'',
						username:_this.user.name,	
						password:_this.user.psd,	
						address:'',		
						email:_this.user.email,			
						legal:'',	
						qualifications:'',	
						contact_name:_this.user.contactName,	
						mobile:_this.mobile,	
						verify:_this.yzm,	
						type:_this.type,	
						business_email:	''
					});
					if (status == _this.SUCCESS_CODE) {
						  _this.$message({
							message: '注册成功！审核状态可在个人中心查看',
							type: 'success'
						  });
						  _this.$setStorage('userToken',data.userToken)
						  _this.show = true
						 //  _this.$router.go(-1);
					} else {
						 _this.$message.error(message);
					}
				}
							  
			},
			// 发送验证码
			sendYanzheng(){
			    var _this = this;
			    if (!/^1[2-9]\d{9}$/.test(_this.mobile)) {
					_this.$message({
					  message: '请输入有效的手机号',
					  type: 'warning'
					});
					_this.isMobile = true
			        return false;
			    }else{
					_this.isMobile = false
				}
			    if (_this.send != '发送验证码') return;
				_this.getVerify()
			},
			async getVerify() {
				var _this = this;
				_this.isMobile = false
			   let { status, message, data } = await _this.$ajax('verify', {
			   	mobile:_this.mobile,
				type:1
			   });
			   if (status == _this.SUCCESS_CODE) {
				   // _this.yzm = data
				   _this.$message({
						message: '发送成功！请注意查收',
						type: 'success'
				   });
					_this.countDown()
			   } else {
			        _this.$message.error(message);
			   }
			},
			// 验证码倒计时
			countDown() { //验证码倒计时
			    var _this = this;
			    switch (_this.send) {
			        case '发送验证码':
			            _this.send = _this.time + 's';
			            var timer = setInterval(function () {
			                if (--_this.time <= 0) {
			                    clearInterval(timer);
			                    _this.send = '发送验证码';
			                    _this.time = 60;
			                } else {
			                    _this.send = _this.time + 's';
			                }
			            }, 1000);
			            break;
			    }
			},
			 handleRemove(file, fileList) {
				 this.business.qualifications = ''
			       console.log(file, fileList);
			  },
			  handlePreview(file) {
				window.open(file.url);
			  },
			  handleExceed(files, fileList) {
				  console.log(files)
				  console.log(fileList)
				// this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			  },
			 
			  beforSuccess(e){
				  console.log(e)
				  this.fileList = []
				  
				  this.business.qualifications = ''
				  var a = {
					  name:e.data.title,
					  url:e.data.attach_uri
				  }
				  this.business.qualifications = e.data.id
				  this.fileList.push(a)
				
			  },
			  beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			  }
        }
    }
</script>

<style scoped>

    .title {
        font-size: 23px;
        font-weight: bold;
        padding-top: 60px;
    }
    .tab {
        padding-top: 23px;
        display: flex;
        justify-content: center;
    }
    .tab .tab__item {
        width: 140px;
        line-height: 47px;
        background: #e5e5e5;
        font-size: 18px;
        font-weight: bold;
        color: #535353;
        cursor: pointer;
    }
    .tab .tab__item:first-child {
        margin-right: 15px;
    }
    .tab .tab__item.active {
        background: #af2f24;
        color: #ffffff;
    }
    .main {
        display: flex;
        justify-content: center;
        padding-top: 35px;
    }
    .main__item {
        margin-right: 60px;
    }
    .input-box {
        display: flex;
        height: 75px;
    }
    .upload-box {
        display: flex;
        /* height: 93px; */
    }
    .upload-box div {
        text-align: left;
    }
    .input-box >span, .upload-box >span {
        display: inline-block;
        line-height: 42px;
        width: 80px;
        text-align: left;
    }
    .input-box .input {
        border: 1px solid #dfdfdf;
        border-radius: 5px;
        width: 340px;
        padding: 1px 16px;
        box-shadow: 0 2px 5px #eaeaea;
    }
    .tip {
        color: #ff1400;
        padding-top: 3px;
        text-align: left;
        padding-left: 3px;
    }
    .tel {
        display: flex;
        align-items: center;
    }
    .tel .input {
        width: 213px;
        margin-right: 15px;
    }
    .el-button--primary {
        color: #FFF;
        background-color: #106a95;
        border-color: #106a95;
        line-height: 18px;
        transition: .3s;
    }
    .el-button--primary:hover {
        background-color: rgba(16, 106,149, .8);
        border-color: rgba(16, 106,149, .8);
    }
    .agreement {
        padding-top: 20px;
    }
    .agreement span {
        color: #0066cc;
    }
    .submit_btn {
        color: #fff;
        background: #af2f24;
        font-weight: bold;
        font-size: 20px;
        line-height: 46px;
        width: 250px;
        border-radius: 3px;
        margin: 20px 0 65px;
        cursor: pointer;
    }
    /* 顶部 */
    .nTop .nt-link1{display: block;width: 113px;height: 42px;border: 1px solid #dcdcdc;text-align: center;line-height: 40px;font-size: 16px;color: #838383;float: right;margin-top: 25px;transition: .5s;background-color: #fff;}
    .nTop .nt-link1:hover{background: #dcdcdc;}
	/* .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner */
	.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
		background-color:#af2f24;
	}
	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
	/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
		background-color: #c00;
		border-color: #c00;
	}
	/deep/ .el-checkbox__inner:hover{
		border-color: #c00;
	}
	/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
		color: #c00;
	}
	/deep/ .el-dialog__body{
		padding: 20px !important;
	}
	/deep/ .el-dialog__header{
		padding: 0px !important;
	}
	.pop_tip{
		font-size:13px ;
		padding: 5px 7px;
		background-color: #ffffe5;
		border: 1px solid #ffcc7f;
		width: 65%;
		/* margin-bottom: 30px; */
	}
	.pop_address_box{
		width: 70%;
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		border: 1px solid #b07b40;
	}
	.pop_address{
		padding: 3px;
		font-size: 15px;
		font-weight: bold;
		background-color: #b07b40;
		color: #fff;
		margin-bottom: 7px;
	}
	.pop_address_item{
		font-size: 15px;
		text-align: center;
		margin-bottom: 7px;
		color: #000;
	}
	/deep/ .dialog .input_box .el-input-group__append{
		background-color: #FFF !important;
		border: none !important;
		color: red;
	}
	/deep/.input_box .el-input__inner, .el-input-group__prepend{
		padding: 0px 15px;
	}
	/deep/.input_box .el-input-group__append{
		background-color: #FFF !important;
		border: none !important;
		color: #000;
	}
	.pop_box{
		display: flex;
		flex-direction: column;
		/* align-items: center; */
	}
	.pop_image_box{
		display: flex;
		align-items: center;
		flex-direction: column;
		align-items: center;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 30px;
		color: #000;
	}
	.pop_image_box img{
		display: block;
		margin-bottom: 10px;
		width: 60px;
		height: 60px;
	}
	.input_box{
		margin-bottom: 10px;
		width: 100%;
		border: 1px solid #dddddd; 
	}
	.pop_btn{
		width:100%;
		height:45px;
		line-height:45px; 
		font-weight: bold;
		text-align:center;
		border-radius: 4px;
		color:#fff;
		font-size:14px;
		margin: 15px 0px;
		background-color:#af2f24;
	}
	
</style>



// WEBPACK FOOTER //
// src/views/register/register.vue